import PropTypes from 'prop-types';

export const SearchProducts = Object.freeze({
    DYNPACK: 'dynpack',
    DYNPACK_OF2: 'dynpack_of2',
    FLIGHTS: 'flights',
    INSPIRATIONAL: 'inspirations',
    HOTEL_STANDALONE: 'hotel_standalone',
    HOTELS_HOME: 'hotels_home',
    TRAINS: 'trains'
});

export const SearchProductsProp = PropTypes.oneOf(Object.values(SearchProducts));
